import { InjectionToken } from '@angular/core';

export interface SnackBarConfig {
  textClasses?: string;
  baseContainerClasses?: string;
  successContainerClasses?: string;
  errorContainerClasses?: string;
  defaultVerticalPosition?: 'top' | 'bottom';
  defaultHorizontalPosition?: 'left' | 'right';
}

export const SNACK_BAR_CONFIG = new InjectionToken<SnackBarConfig>(
  'SNACK_BAR_CONFIG'
);
